import { useState } from 'react';
import LoginForm from '@/components/auth/LoginForm';
import RegisterForm from '@/components/auth/RegisterForm';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface AuthDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AuthDialog({ open, onOpenChange }: AuthDialogProps) {
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const close = () => onOpenChange(false);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-[#0d1b2e] border-white/10 text-white p-0">
        <DialogHeader className="px-6 pt-6">
          <DialogTitle>{mode === 'login' ? 'Sign in' : 'Create account'}</DialogTitle>
        </DialogHeader>
        <div className="px-6 pb-6">
          {mode === 'login' ? (
            <LoginForm embedded onClose={close} onSwitchToRegister={() => setMode('register')} />
          ) : (
            <RegisterForm embedded onClose={close} onSwitchToLogin={() => setMode('login')} />
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function LoginPrompt({ message = 'Sign in to continue' }: { message?: string }) {
  const [mode, setMode] = useState<'login' | 'register'>('login');

  return (
    <div className="flex min-h-screen items-center justify-center px-6 py-12">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#0d1b2e] p-8 shadow-xl">
        <h1 className="font-display text-2xl font-semibold mb-2">
          {mode === 'login' ? 'Sign in' : 'Create account'}
        </h1>
        <p className="text-white/60 text-sm mb-6">{message}</p>
        {mode === 'login' ? (
          <LoginForm
            embedded
            onClose={() => {}}
            onSwitchToRegister={() => setMode('register')}
          />
        ) : (
          <RegisterForm
            embedded
            onClose={() => {}}
            onSwitchToLogin={() => setMode('login')}
          />
        )}
      </div>
    </div>
  );
}
